import * as Card from '../../../shared/card'
import { Toggle } from '../../../shared/NarusMaterial'
import { useIGAO } from '../../context'
import { getDetail } from '../../utils'
import { Filter } from '../selects'

import styles from './header.module.scss'
import tooltipStyles from './tooltip.module.scss'

const ToolTip = () => (
  <div className={tooltipStyles.help}>
    <div className={tooltipStyles.tooltipContainer}>
      <div className={tooltipStyles.infoIcon}>
        <span style={{ fontWeight: 500, verticalAlign: 'baseline' }}>
          ?
        </span>
      </div>
      <div className={tooltipStyles.tooltip}>
        <div className={tooltipStyles.tooltipGrid}>
          <div>
            <span>Autosave</span>
            <span>All questionnaire changes are saved on the fly.</span>
          </div>
          <div>
            <span>Draft</span>
            <span>
              Changes in the draft mode are not visible to other users.
            </span>
          </div>
          <div>
            <span>Publish</span>
            <span>
              Click the Publish button to publish your changes to the patient
              chart.
            </span>
          </div>
          <div>
            <span>Enter</span>
            <span>Press Enter to submit an issue/action/comment.</span>
          </div>
          <div>
            <span>Apply</span>
            <span>Click outside an issue/action to submit your changes</span>
          </div>
          <div>
            <span>Esc</span>
            <span>Press Esc to exit editing mode and cancel changes.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export function Header ({
  handleAll,
  switchHead,
  setSwitchHead,
  handleSelect,
  open,
  setOpen
}) {
  const { pageData, filters, compactView, setCompactView, page, search, setSearch } = useIGAO()
  const { lists, title } = pageData

  const names = {
    statuses: filters?.status?.map(
      status => lists.status.find(s => s.id === status)?.name
    ),
    issues: filters?.issue?.map(
      status => lists.status.find(s => s.id === status)?.name
    ),
    actions: filters?.action?.map(
      status => lists.status.find(s => s.id === status)?.name
    ),
    assignees: filters?.assignee?.map(
      a => lists.assignee.find(s => s.id === a)?.name
    ),
    pages: filters?.page?.map(
      p => lists.page.find(s => s.id === p)?.name
    )
  }

  const numberOfItemsByStatus = () => {
    const counter = {}
    lists?.status?.map(s =>
      pageData?.items?.map(item =>
        item?.issues?.map(iss => {
          const { status } = getDetail(iss)
          if (status.id === s.id) counter[s.name] = counter[s.name] + 1 || 1
          return iss
        })))
    return counter
  }

  const numberOfItemsByAssignee = () => {
    const counter = {}
    lists?.assignee?.map(a =>
      pageData?.items?.map(item =>
        item?.issues?.map(iss => {
          const { assignee } = getDetail(iss)
          if (assignee.id === a.id) counter[a.name] = counter[a.name] + 1 || 1
          return iss
        })))
    return counter
  }

  const numberOfItemsByPage = () => {
    const counter = {}
    lists?.page?.map(s =>
      pageData?.items?.map(item =>
        item?.issues?.map(iss => {
          if (iss.page === s.id) counter[s.name] = counter[s.name] + 1 || 1
          return iss
        })))
    return counter
  }

  return (
    <Card.Header
      style={{ borderRadius: '16px 16px 0 0' }}
      open={open}
      expandable
      onChangeOpen={setOpen}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
        <h2>{title}</h2>
        <ToolTip />
        <div className={styles.filters}>
          {page === 'careplan' &&
            (
              <>
                <Filter
                  label={`Issue: ${names.issues?.join(', ')}`}
                  relation={filters.issue}
                  key='filters-issue'
                  itemType='status'
                  type='filter'
                  lists={lists}
                  numbersOfSelected={numberOfItemsByStatus()}
                  handler={handleSelect('issue')}
                />
                <Filter
                  label={`Action: ${names.actions?.join(', ')}`}
                  relation={filters.action}
                  key='filters-action'
                  itemType='status'
                  type='filter'
                  lists={lists}
                  handler={handleSelect('action')}
                />
                <Filter
                  label={`Assignee: ${names.assignees?.join(', ')}`}
                  relation={filters.assignee}
                  key='filters-assignee'
                  itemType='assignee'
                  type='filter'
                  lists={lists}
                  numbersOfSelected={numberOfItemsByAssignee()}
                  handler={handleSelect('assignee')}
                />
                <Filter
                  label={`Page: ${names.pages?.join(', ')}`}
                  relation={filters.page}
                  key='filters-page'
                  itemType='page'
                  type='filter'
                  lists={lists}
                  numbersOfSelected={numberOfItemsByPage()}
                  handler={handleSelect('page')}
                />
                {setCompactView && (
                  <Toggle
                    value={compactView}
                    label='Compact View'
                    onChange={() => setCompactView(prev => !prev)}
                  />
                )}
              </>
            )}

          {page === 'tasks' && (
            <>
              <Filter
                label={`Issue: ${names.issues?.join(', ')}`}
                relation={filters.issue}
                key='filters-issue'
                itemType='status'
                type='filter'
                lists={lists}
                numbersOfSelected={numberOfItemsByStatus()}
                handler={handleSelect('issue')}
              />
              <Filter
                label={`Action: ${names.actions?.join(', ')}`}
                relation={filters.action}
                key='filters-action'
                itemType='status'
                type='filter'
                lists={lists}
                handler={handleSelect('action')}
              />
              <Filter
                label={`Page: ${names.pages?.join(', ')}`}
                relation={filters.page}
                key='filters-page'
                itemType='page'
                type='filter'
                lists={lists}
                numbersOfSelected={numberOfItemsByPage()}
                handler={handleSelect('page')}
              />
              <input
                className={styles.searchInput}
                type='text'
                onChange={e => setSearch(e.target.value)}
                placeholder='Search'
                value={search}
              />
            </>
          )}

          {page !== 'careplan' && page !== 'tasks' &&
            (
              <Filter
                label={`Status: ${names.statuses?.join(', ')}`}
                relation={filters.status}
                key='filters-status'
                itemType='status'
                type='filter'
                lists={lists}
                numbersOfSelected={numberOfItemsByStatus()}
                handler={handleSelect('status')}
              />
            )}
        </div>
      </div>
      {page !== 'careplan' && page !== 'tasks' && (
        <div
          style={{
            width: '83px',
            textAlign: 'center',
            alignSelf: 'center'
          }}
        >
          <button
            onClick={() => {
              setSwitchHead(!switchHead)
              handleAll(switchHead)
            }}
            className={styles.igaoHeadSelect}
          >
            {switchHead ? 'clear all' : 'select all'}
          </button>
        </div>
      )}
    </Card.Header>
  )
}
